import React, { useEffect, useState } from "react";
import {
  assignParokiaCashier,
  listCashiersByParokia,
  resetParokiaAdminPassword
} from "../../services/api";
import { getCurrentUser } from "../../services/auth";
import { toast } from "react-toastify";
import "./Cashier.css";

export default function CashierPage() {
  const [cashiers, setCashiers] = useState([]);

  const [cashierForm, setCashierForm] = useState({
    firstName: "",
    lastName: "",
    username: "",
    password: ""
  });

  // ✅ RESET MODAL STATE
  const [showModal, setShowModal] = useState(false);
  const [activeUserId, setActiveUserId] = useState(null);
  const [passwords, setPasswords] = useState({
    newPassword: "",
    confirmPassword: ""
  });

  const user = getCurrentUser();

  /* ================= AUTO USERNAME ================= */
  useEffect(() => {
    const { firstName, lastName } = cashierForm;
    if (firstName || lastName) {
      const username = `${lastName}${firstName?.[0] || ""}`.toLowerCase();
      setCashierForm(prev => ({ ...prev, username }));
    }
  }, [cashierForm.firstName, cashierForm.lastName]);

  /* ================= LOAD CASHIERS ================= */
  const loadCashiers = async () => {
    try {
      const res = await listCashiersByParokia();
      setCashiers(res.data || []);
    } catch (err) {
      console.error(err);
      toast.error("Failed to load cashiers");
    }
  };

  useEffect(() => {
    if (user?.parokiaId) {
      loadCashiers();
    }
  }, [user?.parokiaId]);

  /* ================= CREATE CASHIER ================= */
  const handleCreateCashier = async () => {
    const { firstName, lastName, username, password } = cashierForm;

    if (!firstName || !lastName || !username || !password) {
      toast.error("All fields are required");
      return;
    }

    if (!window.confirm("Create Cashier?")) return;

    try {
      await assignParokiaCashier({
        firstName,
        lastName,
        username,
        password,
        parokiaId: user.parokiaId
      });

      toast.success("Cashier created successfully");

      setCashierForm({
        firstName: "",
        lastName: "",
        username: "",
        password: ""
      });

      loadCashiers();
    } catch (err) {
      toast.error(err?.response?.data?.message || "Failed to create cashier");
    }
  };

  /* ================= OPEN MODAL ================= */
  const openResetModal = (userId) => {
    setActiveUserId(userId);
    setPasswords({ newPassword: "", confirmPassword: "" });
    setShowModal(true);
  };

  /* ================= RESET PASSWORD ================= */
  const handleResetPassword = async () => {
    const { newPassword, confirmPassword } = passwords;

    if (!newPassword || !confirmPassword) {
      toast.error("All fields are required");
      return;
    }

    if (newPassword !== confirmPassword) {
      toast.error("Passwords do not match");
      return;
    }

    try {
      await resetParokiaAdminPassword(activeUserId, newPassword);
      toast.success("Password reset successfully");

      setShowModal(false);
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to reset password");
    }
  };

  return (
    <div className="page-container">
      <h2>Cashier Management</h2>

      {/* CREATE FORM */}
      <div className="card" style={{ marginBottom: "20px" }}>
        <h4>Create Cashier</h4>

        <div className="form-grid">
          <input
            className="input"
            placeholder="First Name"
            value={cashierForm.firstName}
            onChange={(e) =>
              setCashierForm({ ...cashierForm, firstName: e.target.value })
            }
          />

          <input
            className="input"
            placeholder="Last Name"
            value={cashierForm.lastName}
            onChange={(e) =>
              setCashierForm({ ...cashierForm, lastName: e.target.value })
            }
          />

          <input
            className="input"
            placeholder="Username"
            value={cashierForm.username}
            readOnly
          />

          <input
            className="input"
            type="password"
            placeholder="Password"
            value={cashierForm.password}
            onChange={(e) =>
              setCashierForm({ ...cashierForm, password: e.target.value })
            }
          />
        </div>

        <button className="btn primary" onClick={handleCreateCashier}>
          Create Cashier
        </button>
      </div>

      {/* LIST */}
      <div className="card">
        <h4>Cashiers List</h4>

        <table className="table">
          <thead>
            <tr>
              <th>#</th>
              <th>Username</th>
              <th>Name</th>
              <th>Status</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {cashiers.map((c, i) => (
              <tr key={c.user_id}>
                <td>{i + 1}</td>
                <td>{c.username}</td>
                <td>{c.first_name} {c.last_name}</td>
                <td>{c.status}</td>
                <td>
                  <button
                    className="btn warning"
                    onClick={() => openResetModal(c.user_id)}
                  >
                    Reset Password
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ✅ MODAL */}
      {showModal && (
        <div className="modal-overlay">
          <div className="modal">
            <h3>Reset Password</h3>

            <input
              type="password"
              placeholder="New Password"
              className="input"
              value={passwords.newPassword}
              onChange={(e) =>
                setPasswords({ ...passwords, newPassword: e.target.value })
              }
            />

            <input
              type="password"
              placeholder="Confirm Password"
              className="input"
              value={passwords.confirmPassword}
              onChange={(e) =>
                setPasswords({ ...passwords, confirmPassword: e.target.value })
              }
            />

            <div className="modal-actions">
              <button className="btn primary" onClick={handleResetPassword}>
                Save
              </button>

              <button
                className="btn secondary"
                onClick={() => setShowModal(false)}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}